/**
 * Parameter types that accept `${...}` expressions and therefore deserve
 * the token / expression chips. Anything outside this set hides the chips
 * by default.
 *
 * Single source of truth for both the compact `ParameterList` rendering
 * path and any wrapper component that needs to decide whether to expose
 * tokenization affordances.
 */
export const TOKENIZABLE_PARAMETER_TYPES: ReadonlySet<string> = new Set([
  'string',
  'securestring',
  'object',
  'array',
  'integer',
  'number',
  'boolean',
  'any',
]);
